import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Paper,
  Toolbar,
  IconButton,
  Grid,
  TextField,
  Button,
  Box,
  useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { CmpDatePickerField001V1 } from "../../../Component/Common/ToolBox/ToolBoxV1";
import { getGlobals } from "../../../Configs";
import GCAutocompleteCheckboxFixSizeUid from "../../RSPChangeRequest/proccessComponent/GCAutocompleteCheckboxFixSizeUid";

const baseURL = getGlobals().API_BASE_URL;

export const PromotionModal = ({
  xOpen,
  onClose,
  promoId,                 // pass promoId from parent when opening
  xModalfullScreen,
  xModalHeight,
  xLocation,
}) => {
  // ----- state -----
  const [loadingPromotion, setLoadingPromotion] = useState(false);
  const [xRows, setXRows] = useState([]);
  const [formData, setFormData] = useState({});
  const vMediaQuery = useMediaQuery("(max-width:900px)");

  // ----- fetch promotion rows when modal opens -----
  useEffect(() => {
    const fetchPromotion = async () => {
      if (!xOpen || !promoId) return;
      setLoadingPromotion(true);
      try {
        const response = await axios.post(
          `${baseURL}Master/RSPCR_BK_Getrow`,
          { P_PromoId: promoId },
          { headers: { "Content-Type": "application/json" } }
        );

        if (response.status === 200) {
          const promoData = response.data.ResultSet;
          setXRows(Array.isArray(promoData) ? promoData : []);
        } else {
          setXRows([]);
        }
      } catch (err) {
        console.error("Error fetching promotion data:", err);
        setXRows([]);
      } finally {
        setLoadingPromotion(false);
      }
    };

    fetchPromotion();
  }, [xOpen, promoId]);

  const columns = [
    { field: "PromoId", headerName: "Promo Id", width: 70, align: "center", headerAlign: "center" },
    {
      field: "LocName",
      headerName: "Locations",
      width: vMediaQuery && 200,
      flex: vMediaQuery ? 0 : 1,
      headerAlign: "center",
    },
    { field: "Narration", headerName: "Name", width: 200, headerAlign: "center" },
    { field: "Status", headerName: "Status", width: 80, align: "center", headerAlign: "center" },
  ];

  const handleSave = () => {
    console.log("Save data:", formData);
    // add save logic here
  };

  const xRowClick = (params) => {
    console.log("Row clicked:", params.row);
  };

  const toolbar = { display: "flex", justifyContent: "space-between", alignItems: "center" };

  return (
    <Dialog open={xOpen} onClose={onClose} maxWidth="md" fullScreen={xModalfullScreen}>
      <Paper style={{ height: xModalHeight }}>
        <Toolbar sx={toolbar}>
          <span>&nbsp;</span>
          <DialogTitle sx={{ backgroundColor: "#0d73bb", color: "white", padding: "0 4px !important" }}>
            Promotion Basket Modal
          </DialogTitle>
          <IconButton edge="end" color="inherit" onClick={onClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Toolbar>

        <DialogContent sx={{ overflowX: "hidden", overflowY: "auto", padding: "1rem !important" }}>
          <Grid container spacing={2}>
            {/* Promo ID */}
            <Grid item xs={3} sm={2} md={1.5}>
              <TextField
                type="number"
                size="small"
                label="Id"
                value={formData?.PromoId || ""}
                disabled
                sx={{ bgcolor: "lightgray" }}
              />
            </Grid>

            {/* From Date */}
            <Grid item xs={4.5} sm={5} md={2}>
              <CmpDatePickerField001V1
                xLabelText="From Date"
                xValue={formData?.FromDate}
                xOnChange={(newValue) =>
                  setFormData((prev) => ({ ...prev, FromDate: newValue.$d }))
                }
              />
            </Grid>

            {/* To Date */}
            <Grid item xs={4.5} sm={5} md={2}>
              <CmpDatePickerField001V1
                xLabelText="To Date"
                xValue={formData?.ToDate}
                xOnChange={(newValue) =>
                  setFormData((prev) => ({ ...prev, ToDate: newValue.$d }))
                }
              />
            </Grid>

            {/* Location */}
            <Grid item xs={12} sm={6} md={6.5}>
              <GCAutocompleteCheckboxFixSizeUid
                label="Location"
                xValue={formData?.Loc}
                setValue={(updated) => setFormData((prev) => ({ ...prev, Loc: updated }))}
                options={xLocation ?? []}
                placeholder="Search Location"
              />
            </Grid>

            {/* Narration */}
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                size="small"
                label="Name"
                value={formData?.Narration || ""}
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, P_Narration: e.target.value }))
                }
                fullWidth
                autoComplete="off"
              />
            </Grid>

            {/* Save Button */}
            <Grid item xs={12} sm={6} md={8}>
              <Box display="flex" gap={2} sx={{ justifyContent: "flex-end", flexWrap: "wrap" }}>
                <Button size="small" variant="contained" onClick={handleSave}>
                  Save
                </Button>
              </Box>
            </Grid>
          </Grid>

          {/* DataGrid with fetched rows */}
          <Box sx={{ mt: 2, height: { xs: "30vh", sm: "35vh", md: "36vh", lg: "40vh" } }}>
            <DataGridPro
              rows={xRows}
              columns={columns}
              loading={loadingPromotion}
              rowHeight={30}
              headerHeight={30}
              getRowId={(row) => row?.PromoId}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0 ? "mui-even-row" : "mui-odd-row"
              }
              sx={{
                border: 1,
                borderColor: "primary.light",
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#0d73bb",
                  color: "white",
                  fontSize: "10px",
                  padding: "0px !important",
                },
              }}
              onRowClick={xRowClick}
              hideFooter
            />
          </Box>
        </DialogContent>
      </Paper>
    </Dialog>
  );
};
